import React from 'react' 
import { BsPatchCheckFill } from "react-icons/bs"; 
import "./styles.css" 
const data=[
  {
    id:1,
    name:"C++",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
  },
  {
    id:2,
    name:"Dart",
    img:"https://www.vectorlogo.zone/logos/dartlang/dartlang-icon.svg",
  },
  {
    id:3,
    name:"Python",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
  },
  {
    id:4,
    name:"C",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
  },
  {
    id:5,
    name:"JavaScript",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
  },
  {
    id:6,
    name:"Solidity",
    img:"https://soliditylang.org/images/logo.svg",
  },
  {
    id:7,
    name:"TypeScript",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
  },
  {
    id:8,
    name:"Elixir",
    img:"https://www.vectorlogo.zone/logos/elixir-lang/elixir-lang-icon.svg",
  },
  {
    id:9,
    name:"Android",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/android/android-original-wordmark.svg",
  },
  {
    id:10,
    name:"Angular",
    img:"https://angular.io/assets/images/logos/angular/angular.svg",
  },
  {
    id:11,
    name:"Express",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
  },

  {
    id:12,
    name:"Firebase",
    img:"https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
  },

  {
    id:13,
    name:"Git",
    img:"https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
  },


  {
    id:14,
    name:"Java",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  },
  {
    id:15,
    name:"Linux",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
  },
  {
    id:16,
    name:"MongoDB",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
  },
  {
    id:17,
    name:"MySQL",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
  },
  {
    id:18,
    name:"Node.js",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
  },
  {
    id:19,
    name:"MySQL",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
  },
  {
    id:20,
    name:"OpenCV",
    img:"https://www.vectorlogo.zone/logos/opencv/opencv-icon.svg",
  },
  {
    id:21,
    name:"OpenCV",
    img:"https://www.vectorlogo.zone/logos/opencv/opencv-icon.svg",
  },
  {
    id:22,
    name:"Pandas",
    img:"https://raw.githubusercontent.com/devicons/devicon/2ae2a900d2f041da66e950e4d48052658d850630/icons/pandas/pandas-original.svg",
  },
  {
    id:23,
    name:"Postman",
    img:"https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
  },
  {
    id:24,
    name:"Pytorch",
    img:"https://www.vectorlogo.zone/logos/pytorch/pytorch-icon.svg",
  },
  {
    id:25,
    name:"React",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
  },
  {
    id:26,
    name:"Redux",
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
  },
  {
    id:27,
    name:"Scikit Learn",
    img:"https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
  },
  {
    id:28,
    name:"Spring Boot",
    img:"https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
  },
  {
    id:29,
    name:"Sqlite",
    img:"https://www.vectorlogo.zone/logos/sqlite/sqlite-icon.svg",
  },
  {
    id:30,
    name:"Truffle",
    img:"https://trufflesuite.com/assets/logo.png",
  },
    
  {
    id:31,
    name:"Flutter",
    img:"https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg",
  },

]
const Skills = () => { 
  return ( 
  <section id="skills">
    <h2>Technology I have worked with</h2>
    <div className="container skills__container">
        <div className="skills__content">
          <article className="skills__details">
            {
              data.map(({name,img})=>{
                return(
                  <div className='skill__list-div'>
                    <img className='skill__icon' src={img} alt={name} />
                    {name}
                  </div>

                )
              })
            }
          </article>
        </div>
    </div>
  </section> 
  ) 
} 
export default Skills